import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DashboardFilters = ({ onFilterChange, onSortChange, clientCount }) => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [sortBy, setSortBy] = useState('name');
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const filters = [
    { id: 'all', label: 'All Clients', icon: 'Users' },
    { id: 'active', label: 'Active Balance', icon: 'CheckCircle' },
    { id: 'low', label: 'Low Balance', icon: 'AlertTriangle' },
    { id: 'empty', label: 'No Balance', icon: 'AlertCircle' }
  ];

  const sortOptions = [
    { id: 'name', label: 'Name (A-Z)', icon: 'ArrowUpAZ' },
    { id: 'balance-high', label: 'Balance (High-Low)', icon: 'ArrowDown' },
    { id: 'balance-low', label: 'Balance (Low-High)', icon: 'ArrowUp' },
    { id: 'recent', label: 'Recently Added', icon: 'Clock' }
  ];

  const handleFilterChange = (filterId) => {
    setActiveFilter(filterId);
    onFilterChange(filterId);
    setIsFilterOpen(false);
  };

  const handleSortChange = (sortId) => {
    setSortBy(sortId);
    onSortChange(sortId);
  };

  const getFilterCount = () => {
    return clientCount || 0;
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
      {/* Filter Section */}
      <div className="flex items-center space-x-4">
        <div className="relative">
          <Button
            variant="outline"
            onClick={() => setIsFilterOpen(!isFilterOpen)}
            iconName="Filter"
            iconPosition="left"
            iconSize={16}
            className="min-w-0"
          >
            <span className="hidden sm:inline">Filter</span>
            <span className="sm:hidden">
              <Icon name="Filter" size={16} />
            </span>
          </Button>

          {isFilterOpen && (
            <div className="absolute top-full left-0 mt-2 w-48 bg-popover border border-border rounded-lg shadow-lg z-50 animate-fade-in">
              <div className="p-2">
                {filters.map((filter) => (
                  <button
                    key={filter.id}
                    onClick={() => handleFilterChange(filter.id)}
                    className={`w-full flex items-center px-3 py-2 text-sm rounded-md transition-colors duration-150 ${
                      activeFilter === filter.id
                        ? 'bg-primary text-primary-foreground'
                        : 'hover:bg-muted text-foreground'
                    }`}
                  >
                    <Icon name={filter.icon} size={16} className="mr-3" />
                    {filter.label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Active Filter Display */}
        <div className="flex items-center text-sm text-muted-foreground">
          <Icon 
            name={filters.find(f => f.id === activeFilter)?.icon || 'Users'} 
            size={16} 
            className="mr-2" 
          />
          <span className="hidden sm:inline">
            {filters.find(f => f.id === activeFilter)?.label} ({getFilterCount()})
          </span>
          <span className="sm:hidden">
            {getFilterCount()}
          </span>
        </div>
      </div>

      {/* Sort Section */}
      <div className="flex items-center space-x-2">
        <span className="text-sm text-muted-foreground hidden sm:inline">
          Sort by:
        </span>
        <div className="flex items-center space-x-1">
          {sortOptions.map((option) => (
            <Button
              key={option.id}
              variant={sortBy === option.id ? 'default' : 'ghost'}
              size="sm"
              onClick={() => handleSortChange(option.id)}
              iconName={option.icon}
              iconSize={14}
              className="text-xs"
              title={option.label}
            >
              <span className="hidden lg:inline ml-1">
                {option.label}
              </span>
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardFilters;